import { cleanAllLocalStorage } from '../localStorage';
import { cleanAllSessionStorage } from '../sessionStorage';

import { persistor } from '../../../../redux/configureStore';
export const logout = async () => {
  setTimeout(() => {
    persistor.purge().then(() => {
      cleanAllLocalStorage();
      cleanAllSessionStorage();
      window.location.href = '/';
    });
  }, 2000);
};
